import React from 'react';

const Logo = ({ className = "h-16 w-auto", showText = true, textColor = "text-gray-900" }) => {
  const logoUrl = "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1765919414841-Copy%20of%20Pinoy%20General%20Insurance%20Logo%20%28800%20%C3%83%C2%97%20800%20px%29%20%281%29.png";

  return (
    <div className="flex items-center gap-3">
      <img 
        src={logoUrl} 
        alt="Pinoy General Insurance" 
        className={className} 
      />
      {showText && (
        <div className="hidden sm:block">
          <div className={`text-lg font-bold ${textColor}`}>Pinoy General Insurance</div>
          <div className="text-xs text-gray-600">Services</div>
        </div>
      )}
    </div>
  );
};

export default Logo;